import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';

const TokenExpired = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Trigger the animation after the component mounts
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        
      }}
    >
      {/* Card Container */}
      <Box
        sx={{
          backgroundColor: 'rgb(12, 89, 167)',
          color: 'white',
          padding: '30px 50px',
          borderRadius: '32px',
          textAlign: 'center',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
          transform: isVisible ? 'translateY(0)' : 'translateY(-100vh)',
          transition: 'transform 1s ease-out',
        }}
      >
        {/* Title */}
        <Typography variant="h4" gutterBottom>
        Session expirée
        </Typography>

        {/* Description */}
        <Typography variant="body1" gutterBottom>
          Votre session a expiré. Veuillez actualiser la page pour continuer.
        </Typography>

        {/* Refresh Button */}
        <Button
          variant="contained" 
          onClick={() => window.location.reload()}
          sx={{
            marginTop: '20px',
            backgroundColor: 'white',
            color: 'rgb(12, 89, 167)',
            '&:hover': {
              backgroundColor: 'rgb(200, 200, 200)',
            },
          }}
        >
          Actualiser la page
        </Button>
      </Box>
    </Box>
  );
};

export default TokenExpired;